import React, { ChangeEvent, useEffect, useState } from 'react'

import * as yup from 'yup'
import { Formik } from 'formik'
import 'react-circular-progressbar/dist/styles.css'

import Menu from '../../components/UI/UIMenu'
import Modal from '../../components/UI/UIModal'
import UITabBar from '../../components/UI/UITabBar'
import UISwitch from '../../components/UI/UISwitch'
import UIButton from '../../components/UI/UIButton'

import UITextInput from '../../components/UI/UITextInput'
import UIFieldError from '../../components/UI/UIFieldError'
import UISubHeaderComponent from '../../components/UI/UISubHeaderComponent'
import { Icon } from '../../components/Icon'
import { resourcesHeader, SubCategoriesHeader } from '../../data'
import { useQuery, useQueryClient } from 'react-query'
import {
  getCategoriesDataById,
  getCategoryNameById,
  getResourceDataById,
} from './apiCalls'

import {
  createResource,
  createSubCategory,
  deleteCategory,
  deleteCategoryResource,
  updateCategory,
} from '../../api/admin/resources'
import {
  // resourceCategoryFormData,
  resourceCategoryFormData2,
  resourceOb,
  resourcesCategoriesResponse,
  resourceSubCategoryFormData,
  UploadResponse,
} from '../../utils/types'
import { toast } from 'react-toastify'
import { fileUpload } from '../../api/apiService'
import PdfViewer from '../../components/UI/PdfViewer'

const validationSchema = yup.object().shape({
  subCategoryName: yup.string().required('Sub Category Name is Required'),
})
interface CategoriesProps {
  id: string
  sId: string
  categoryName: string
  setCategoryName?: React.Dispatch<React.SetStateAction<string>> | undefined
  setParentCategoryName?:
    | React.Dispatch<React.SetStateAction<string>>
    | undefined
  setId?: React.Dispatch<React.SetStateAction<string>>
  setBreadcrumbArray?: React.Dispatch<
    React.SetStateAction<
      {
        id: string
        name: string
      }[]
    >
  >
}
interface CategoriesMainProps {
  setIsView: React.Dispatch<React.SetStateAction<string>>
  id: string
  sId: string
  setId: React.Dispatch<React.SetStateAction<string>>
  setBreadcrumbArray?: React.Dispatch<
    React.SetStateAction<
      {
        id: string
        name: string
      }[]
    >
  >
  breadcrumbArray?: {
    id: string
    name: string
  }[]
}
const initialData = {
  name: '',
  parentId: '',
  candidateAccess: false,
  resources: [],
}

interface SubCategoriesHeaderInterface {
  'Sub Category Name': string
  'Candidate Access': string
  Categories: string
  Resources: string
}

const SubCategoriesTab: React.FC<CategoriesProps> = ({
  id,
  sId,

  setCategoryName,

  setId,
  setBreadcrumbArray,
}) => {
  // const [currentPage, setCurrentPage] = useState<number>(1)
  const queryClient = useQueryClient()
  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const [isOpenEditModal, setIsOpenEditModal] = useState(false)
  console.log('id', id)
  console.log('sid', sId)

  const [subCatId, setSubCatId] = useState(id)
  const [catId, setCatId] = useState('')
  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(SubCategoriesHeader?.length || 0).fill(false)
  )
  const [formData, setFormData] =
    useState<resourceCategoryFormData2>(initialData)
  // const [sId, setSId] = useState('')
  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('name')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  const categoriesById = useQuery(['categoriesById', subCatId], () =>
    getCategoriesDataById(
      subCatId,
      // currentPage,
      sortBy,
      sortOrderValue,
      sId
    )
  )
  useEffect(() => {
    setSubCatId(id)
  }, [id])

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    //  console.log(' newSortOrder[key]', key)
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      //  console.log(' newSortOrder[testjdjsn]', newSortOrder[key])
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  useEffect(() => {
    categoriesById.refetch() // Refetch Categories By Id when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue, subCatId, id])
  // useEffect(() => {
  //   console.log('>>>>>>>>>', categoriesById?.data?.category?.name)
  //   if (categoriesById?.data && setCategoryName) {
  //     setCategoryName(categoriesById.data.category?.name ?? '')
  //   }

  //   // Refetch Categories By Id when sortBy or sortOrderValue changes
  // }, [sId, id])

  // const handlePageChange = (pageNumber: number): void => {
  //   setCurrentPage(pageNumber)
  //   // You can add additional logic here, like fetching data for the new page
  // }

  const handleChange = (fieldName: string, value: string | boolean): void => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  const handleToggleMenu = (rowIndex: number | null) => {
    const updatedMenuState = isOpenMenu?.map(
      (isOpen: unknown, index: number) => (index === rowIndex ? !isOpen : false)
    )
    setIsOpenMenu(updatedMenuState)
  }

  const statusBgColor = (status: boolean): string => {
    switch (status) {
      case true:
        return 'lightGreen'
      case false:
        return 'paleYellow'
      default:
        return 'gray3'
    }
  }

  const removeCategory = async (): Promise<void> => {
    try {
      const response = (await deleteCategory({ id: subCatId })) as {
        status?: string
        data: resourcesCategoriesResponse
      }
      if (response?.status == 'successful') {
        categoriesById.refetch()
        queryClient.fetchQuery(['categoriesById', subCatId])
        setIsOpenDelete(false)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }

  const editResourceCategory = async (): Promise<void> => {
    const response = (await updateCategory(formData, catId)) as {
      status?: string
      data: resourcesCategoriesResponse
    }
    if (response?.status == 'successful') {
      categoriesById.refetch()
      setIsOpenEditModal(false)
      queryClient.fetchQuery(['categoriesById', subCatId])

      toast.success('Category Updated.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  return (
    <>
      <div className="overflow-hidden rounded-[16px] w-full">
        <table className="rounded-[16px] overflow-hidden border w-full border-white">
          <thead>
            <tr className="bg-gray2 cursor-pointer">
              {SubCategoriesHeader?.map((item, index: number) => {
                return (
                  <th
                    key={index}
                    className={`w-1/8 px-4 py-3 text-left ${index === 0 ? 'rounded-l-lg' : ''} ${SubCategoriesHeader?.length - 1 === index ? 'border-none' : 'border-r border-white'}`}
                  >
                    <div className="flex items-center">
                      <p className="text-text1 font-semibold text-sm flex-1">
                        {item.replace(/_/g, ' ')}
                      </p>
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          let sortBy = ''
                          switch (item as keyof SubCategoriesHeaderInterface) {
                            case 'Sub Category Name':
                              sortBy = 'name'
                              break
                            case 'Candidate Access':
                              sortBy = 'candidateAccess'
                              break
                            case 'Categories':
                              sortBy = 'sub_categories'
                              break
                            case 'Resources':
                              sortBy = 'resources'
                              break
                            default:
                              break
                          }
                          handleSort(sortBy)
                        }}
                      >
                        <Icon
                          name={'IconChevronDown'}
                          width={16}
                          height={16}
                          strokeWidth={1}
                          stroke={'#67A5B9'}
                        />
                      </div>
                    </div>
                  </th>
                )
              })}
              {/* <th className="w-1/8 px-4 py-3 border text-left border-white"></th> */}
            </tr>
          </thead>
          <tbody>
            {categoriesById?.data?.data?.map((item, index) => (
              <>
                <tr className="bg-gray1">
                  <td
                    onClick={() => {
                      setSubCatId(item.id)
                      console.log('catid', item.id)
                      setCategoryName && setCategoryName(item.name)
                      // setParentCategoryName&&setParentCategoryName(categoryName)
                      setId?.(item.id)
                      setBreadcrumbArray &&
                        setBreadcrumbArray((prev) => [
                          ...prev,
                          {
                            id: item.id,
                            name: item.name,
                          },
                        ])
                    }}
                    className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white"
                  >
                    {item.name}
                  </td>
                  <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                    <div
                      className={`rounded-[40px] w-[40px] flex justify-center items-center h-[28px] bg-${statusBgColor(item.candidateAccess)}`}
                    >
                      <p className="text-xs text-text2 font-medium">
                        {item.candidateAccess == true ? 'Yes' : 'No'}
                      </p>
                    </div>
                  </td>
                  <td className="px-4  h-[48px] py-2 border border-white">
                    <div className="flex">
                      <p className="text-text1 font-medium text-[12px] flex-1">
                        {item.sub_categories}
                      </p>
                    </div>
                  </td>
                  <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                    <div className="flex">
                      <p className="px-4 text-text1 font-medium text-[12px] flex-1">
                        {item.resources}
                      </p>
                      <div className="mr-4 cursor-pointer">
                        <Menu
                          isOpen={isOpenMenu[index]}
                          items={[
                            {
                              label: 'View',
                              onClick: () => {
                                setSubCatId(item.id)
                              },
                              icon: 'IconEye',
                              iconColor: '',
                            },
                            {
                              label: 'Edit',
                              onClick: () => {
                                setCatId(item?.id)

                                setFormData({
                                  name: item.name,
                                  parentId: item.parentId,
                                  candidateAccess: false,
                                  resources: [],
                                })

                                setIsOpenEditModal(!isOpenEditModal)
                                setCatId(item.id)
                              },
                              icon: 'IconEdit',
                              iconColor: '',
                            },
                            {
                              label: 'Remove',
                              onClick: () => {
                                setIsOpenDelete(true)
                                setSubCatId(item.id)
                              },
                              icon: 'IconTrash',
                              iconColor: '#FF6666',
                              textColor: 'text-textError',
                            },
                          ]}
                          type={'table'}
                          setIsOpenMenu={setIsOpenMenu}
                          isOpenMenus={isOpenMenu}
                        >
                          <div
                            onClick={() => {
                              handleToggleMenu(index)
                            }}
                          >
                            <Icon
                              name={'IconDotsVertical'}
                              width={16}
                              height={16}
                              strokeWidth={1.5}
                              stroke={'#02698C'}
                            />
                          </div>
                        </Menu>
                      </div>
                    </div>
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
        {/* <div className="absolute bottom-10">
      
          <Pagination
            currentPage={currentPage}
            totalPages={calculatePageCount(categoriesById?.data?.length || 0)}
            onPageChange={handlePageChange}
          />
        </div> */}
      </div>
      {/* Delete Category Modal */}
      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 20px' }}
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(!isOpenDelete)}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => setIsOpenDelete(!isOpenDelete)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center mb-4">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Delete Sub Category
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Are you sure you want to delete this sub category?
            </p>
          </div>
          <div className="w-full flex flex-col gap-4">
            <button
              onClick={() => {
                removeCategory()
                console.log('del')
              }}
              className="text-textError border-textError border-[1px] min-h-[48px] font-medium rounded-[72px] text-[14px]"
            >
              Yes, I’m sure
            </button>
            <button
              onClick={() => {
                setIsOpenDelete(false)
              }}
              className="text-text3 border-textError bg-gray2 min-h-[48px] font-medium rounded-[72px] text-[14px]"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      {/* Edit Category Modal */}
      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 6px' }}
        isOpen={isOpenEditModal}
        onClose={() => setIsOpenEditModal(!isOpenEditModal)}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => setIsOpenEditModal(!isOpenEditModal)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconTool'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Edit Category
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please specify the name and access of this category
            </p>
          </div>
          <div className="w-[416px] flex-col flex gap-8 mt-6">
            <div>
              <UITextInput
                label={'Sub Category Name*'}
                value={formData.name}
                onChange={(e) => {
                  handleChange('name', e.target.value)
                }}
                placeholder="Please enter your sub category name"
                iconName={''}
              />
            </div>
            <div className="w-full p-4 bg-gray1 rounded-xl flex">
              <div className="flex-1">
                <p className="text-sm font-semibold leading-6 text-text4">
                  Staff Access
                </p>
                <p className="text-sm font-normal leading-6 text-text3">
                  Can clients can access files in this sub category?
                </p>
              </div>
              <div>
                <UISwitch
                  value={formData.candidateAccess}
                  onValueChange={(e: boolean) => {
                    handleChange('candidateAccess', e)
                  }}
                />
              </div>
            </div>
            {/* <div className="flex flex-col gap-1">
              <p className="text-xs font-medium leading-5 text-text1">
                Resource Documents
              </p>
              <div className="w-full p-5 py-3 bg-gray1 rounded-xl flex gap-2">
                <div className="mt-1">
                  <Icon
                    name={'IconFile'}
                    stroke={'#02698C'}
                    strokeWidth={1}
                    height={16}
                    width={16}
                  />
                </div>
                <div className="flex flex-col flex-1 gap-2">
                  <div className="flex gap-2 items-center">
                    <p className="text-sm font-semibold leading-6 text-bluishGreen flex-1 p-0">
                      {'Name of file.pdf'}
                    </p>
                    <div className="cursor-pointer">
                      <Icon
                        name={'IconTrash'}
                        stroke={'#02698C'}
                        strokeWidth={1}
                        height={16}
                        width={16}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-xs font-medium leading-5 text-text3">
                Maximum file size: 5 Mb
              </p>
            </div> */}
            <UIButton
              onClick={editResourceCategory}
              type="submit"
              label="Update"
            />
          </div>
        </div>
      </Modal>
    </>
  )
}

interface resourcesHeaderInterface {
  title: string
  file: string
  'created At': string
  'Updated At': string
}

const ResourcesTab: React.FC<CategoriesProps> = ({ id, sId }) => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [isOpenPdfViewer, setIsOpenPdfViewer] = useState<boolean>(false)
  const [pdfUrl, setPdfUrl] = useState('')
  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const [isOpenEditModal, setIsOpenEditModal] = useState(false)
  const [switchValue, setSwitchValue] = useState<boolean>(false)
  const [subCatId, setSubCatId] = useState('')
  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(SubCategoriesHeader?.length || 0).fill(false)
  )
  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('name')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  const resourcesById = useQuery(['resourcesById', id], () =>
    getResourceDataById(id, sId, currentPage, sortBy, sortOrderValue)
  )

  console.log('testig', resourcesById)

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    //  console.log(' newSortOrder[key]', key)
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      //  console.log(' newSortOrder[testjdjsn]', newSortOrder[key])
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
      setCurrentPage(1)
    }
    setSortOrder(newSortOrder)
  }

  useEffect(() => {
    resourcesById.refetch() // Refetch Resources By Id when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  const handleSwitchChange = (value: boolean) => {
    setSwitchValue(value)
  }

  const handleToggleMenu = (rowIndex: number | null) => {
    const updatedMenuState = isOpenMenu.map((isOpen: unknown, index: number) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const removeCategory = async (): Promise<void> => {
    try {
      const response = (await deleteCategoryResource({ id: subCatId })) as {
        status?: string
        data: resourcesCategoriesResponse
      }
      if (response?.status == 'successful') {
        // categoriesById.refetch()
        resourcesById.refetch()

        setIsOpenDelete(false)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }

  useEffect(() => {
    resourcesById.refetch()
  }, [currentPage])

  const statusBgColor = (status: boolean): string => {
    switch (status) {
      case true:
        return 'lightGreen'
      case false:
        return 'paleYellow'
      default:
        return 'gray3'
    }
  }

  return (
    <>
      <div className="overflow-hidden rounded-[16px] w-full">
        <table className="rounded-[16px] overflow-hidden border w-full border-white">
          <thead>
            <tr className="bg-gray2 cursor-pointer">
              {resourcesHeader?.map((item, index: number) => {
                return (
                  <th
                    key={index}
                    className={`w-1/8 px-4 py-3 text-left ${index === 0 ? 'rounded-l-lg' : ''} ${SubCategoriesHeader?.length - 1 === index ? 'border-none' : 'border-r border-white'}`}
                  >
                    <div className="flex items-center">
                      <p className="text-text1 font-semibold text-sm flex-1">
                        {item.replace(/_/g, ' ')}
                      </p>
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          let sortBy = ''
                          switch (item as keyof resourcesHeaderInterface) {
                            case 'title':
                              sortBy = 'name'
                              break
                            case 'file':
                              sortBy = 'file'
                              break
                            case 'created At':
                              sortBy = 'createdAt'
                              break
                            case 'Updated At':
                              sortBy = 'updatedAt'
                              break
                            default:
                              break
                          }
                          handleSort(sortBy)
                        }}
                      >
                        <Icon
                          name={'IconChevronDown'}
                          width={16}
                          height={16}
                          strokeWidth={1}
                          stroke={'#67A5B9'}
                        />
                      </div>
                    </div>
                  </th>
                )
              })}
              {/* <th className="w-1/8 px-4 py-3 border text-left border-white"></th> */}
            </tr>
          </thead>
          <tbody>
            {resourcesById?.data?.data.map((item, index) => (
              <>
                <tr className="bg-gray1">
                  <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                    {item.name}
                  </td>
                  <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                    <div
                      className={`rounded-[40px] w-[40px] flex justify-center items-center h-[28px] `}
                    >
                      <p className="text-xs text-text1 font-medium">
                        {item.name}.pdf
                      </p>
                    </div>
                  </td>
                  <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                    <div
                      className={`rounded-[40px] w-[40px] flex justify-center items-center h-[28px] bg-${statusBgColor(item.candidateAccess)}`}
                    >
                      <p className="text-xs text-text2 font-medium">
                        {item.candidateAccess == true ? 'Yes' : 'No'}
                      </p>
                    </div>
                  </td>
                  <td className="px-4  h-[48px] py-2 border border-white">
                    <div className="flex">
                      <p className="text-text1 font-medium text-[12px] flex-1">
                        {item.createdAt?.substring(0, 16)}
                      </p>
                    </div>
                  </td>
                  <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                    <div className="flex">
                      <p className="px-4 text-text1 font-medium text-[12px] flex-1">
                        {item.updatedAt?.substring(0, 16)}
                      </p>
                      <div className="mr-4 cursor-pointer">
                        <Menu
                          isOpen={isOpenMenu[index]}
                          items={[
                            {
                              label: 'View',
                              onClick: () => {
                                const url = item.downloadUrl

                                if (!url) return

                                if (
                                  (url as unknown as string) == 'IN PROGRESS'
                                ) {
                                  return toast.warning(
                                    'Scanning the file, please check again in a few seconds.',
                                    {
                                      position: 'top-right',
                                    }
                                  )
                                }
                                if ((url as unknown as string) == 'NoSuchKey') {
                                  return toast.warning('File is removed', {
                                    position: 'top-right',
                                  })
                                }

                                setPdfUrl(`${url}`)
                                setIsOpenPdfViewer(true)
                              },
                              icon: 'IconEye',
                              iconColor: '',
                            },
                            // {
                            //   label: 'Edit',
                            //   onClick: () =>
                            //     setIsOpenEditModal(!isOpenEditModal),
                            //   icon: 'IconEdit',
                            //   iconColor: '',
                            // },
                            {
                              label: 'Remove',
                              onClick: () => {
                                setIsOpenDelete(true)
                                setSubCatId(item.id)
                              },
                              icon: 'IconTrash',
                              iconColor: '#FF6666',
                              textColor: 'text-textError',
                            },
                          ]}
                          type={'table'}
                        >
                          <div
                            onClick={() => {
                              handleToggleMenu(index)
                            }}
                          >
                            <Icon
                              name={'IconDotsVertical'}
                              width={16}
                              height={16}
                              strokeWidth={1.5}
                              stroke={'#02698C'}
                            />
                          </div>
                        </Menu>
                      </div>
                    </div>
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
      {/* Delete Category Modal */}
      <PdfViewer
        isOpen={isOpenPdfViewer}
        onClose={() => {
          setIsOpenPdfViewer(false)
        }}
        url={pdfUrl}
        title="PDF Viewer"
      />
      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 20px' }}
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(!isOpenDelete)}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => setIsOpenDelete(!isOpenDelete)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center mb-4">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Delete Sub Category
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Are you sure you want to delete this sub category?
            </p>
          </div>
          <div className="w-full flex flex-col gap-4">
            <button
              onClick={() => {
                removeCategory()
                console.log('del')
              }}
              className="text-textError border-textError border-[1px] min-h-[48px] font-medium rounded-[72px] text-[14px]"
            >
              Yes, I’m sure
            </button>
            <button
              onClick={() => {
                setIsOpenDelete(false)
              }}
              className="text-text3 border-textError bg-gray2 min-h-[48px] font-medium rounded-[72px] text-[14px]"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      {/* Edit Category Modal */}
      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 6px' }}
        isOpen={isOpenEditModal}
        onClose={() => setIsOpenEditModal(!isOpenEditModal)}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => setIsOpenEditModal(!isOpenEditModal)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconTool'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Edit Category
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please specify the name and access of this category
            </p>
          </div>
          <Formik
            enableReinitialize
            initialValues={{
              subCategoryName: '',
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              console.log('values', values)
            }}
          >
            {({ handleSubmit, errors, handleChange, values, handleBlur }) => (
              <>
                <div className="w-[416px] flex-col flex gap-8 mt-6">
                  <div>
                    <UITextInput
                      error={errors?.subCategoryName}
                      label={'Sub Category Name*'}
                      value={values.subCategoryName}
                      onChange={handleChange('subCategoryName')}
                      onBlur={handleBlur('subCategoryName')}
                      placeholder="Please enter your sub category name"
                      iconName={''}
                    />
                    {errors.subCategoryName ? (
                      <UIFieldError
                        className="mt-2"
                        errorMessage={errors.subCategoryName}
                      />
                    ) : null}
                  </div>
                  <div className="w-full p-4 bg-gray1 rounded-xl flex">
                    <div className="flex-1">
                      <p className="text-sm font-semibold leading-6 text-text4">
                        Staff Access
                      </p>
                      <p className="text-sm font-normal leading-6 text-text3">
                        Can clients access files in this sub category?
                      </p>
                    </div>
                    <div>
                      <UISwitch
                        value={switchValue}
                        onValueChange={handleSwitchChange}
                      />
                    </div>
                  </div>
                  {/* <div className="flex flex-col gap-1">
                    <p className="text-xs font-medium leading-5 text-text1">
                      Resource Documents
                    </p>
                    <div className="w-full p-5 py-3 bg-gray1 rounded-xl flex gap-2">
                      <div className="mt-1">
                        <Icon
                          name={'IconFile'}
                          stroke={'#02698C'}
                          strokeWidth={1}
                          height={16}
                          width={16}
                        />
                      </div>
                      <div className="flex flex-col flex-1 gap-2">
                        <div className="flex gap-2 items-center">
                          <p className="text-sm font-semibold leading-6 text-bluishGreen flex-1 p-0">
                            {'Name of file.pdf'}
                          </p>
                          <div className="cursor-pointer">
                            <Icon
                              name={'IconTrash'}
                              stroke={'#02698C'}
                              strokeWidth={1}
                              height={16}
                              width={16}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <p className="text-xs font-medium leading-5 text-text3">
                      Maximum file size: 5 mb
                    </p>
                  </div> */}
                  <UIButton
                    onClick={handleSubmit}
                    type="submit"
                    label="Update"
                  />
                </div>
              </>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  )
}

const SubCategories: React.FC<CategoriesMainProps> = ({
  id,
  setIsView,
  sId,
  setId,
  setBreadcrumbArray,
  breadcrumbArray,
}) => {
  const queryClient = useQueryClient()
  const [isOpenCreateModal, setIsOpenCreateModal] = useState(false)
  const [isOpenDocumentModal, setIsOpenDocumentModal] = useState(false)
  const [categoryName, setCategoryName] = useState('')
  // const [parentCategoryName, setParentCategoryName] = useState('')

  const [formData, setFormData] =
    useState<resourceSubCategoryFormData>(initialData)
  const [formDataDocument, setFormDataDocument] = useState({
    name: '',
    url: '',
    candidateAccess: false,
  })
  const [activeTab, setActiveTab] = useState<string>('Sub Categories')
  const [selectedFile, setSelectedFile] = useState<File | null>(null)

  const handleDragOver = (event: { preventDefault: () => void }) => {
    event.preventDefault()
  }

  useEffect(() => {
    console.log('breadycr', breadcrumbArray)
  }, [])

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    const file = event.dataTransfer.files[0]
    if (file) {
      setSelectedFile(file)
    }
  }

  console.log('new', formData)

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('resources', [
          {
            name: 'test',
            url: response?.url,
          },
        ])
        setSelectedFile(file)
      } catch (error) {
        setSelectedFile(null)
        handleChange('resources', [])
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
  }
  const handleFileChangeMainCategory = async (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleFileDataChange('url', response?.url)
        setSelectedFile(file)
      } catch (error) {
        setSelectedFile(null)
        handleChange('resources', [])
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
  }

  const handleRemoveFile = () => {
    setSelectedFile(null)
  }

  const handlePressTab = (tab: string) => {
    setActiveTab(tab)
  }

  const createNewSubCategory = async (): Promise<void> => {
    const response = (await createSubCategory(formData)) as {
      status?: string
      data: resourcesCategoriesResponse
    }
    if (response?.status == 'successful') {
      // categoriesById.refetch()
      // setIsEdit(false)
      setFormData(initialData)
      queryClient.invalidateQueries(['categoriesById', id])
      // setIsOpenCreateModal(false)
      setIsOpenCreateModal(false)
      toast.success('Category Created.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const createNewResource = async (): Promise<void> => {
    const response = (await createResource(formDataDocument, id)) as {
      status?: string
      data: resourcesCategoriesResponse
    }
    if (response?.status == 'successful') {
      // categoriesById.refetch()
      // setIsEdit(false)
      setFormDataDocument({
        name: '',
        url: '',
        candidateAccess: false,
      })
      queryClient.invalidateQueries(['resourcesById', id])
      // setIsOpenCreateModal(false)
      setIsOpenDocumentModal(false)
      toast.success('Resource Added.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const handleChange = (
    fieldName: string,
    value: string | resourceOb[] | boolean
  ): void => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }
  const handleFileDataChange = (
    fieldName: string,
    value: string | resourceOb[] | boolean
  ): void => {
    setFormDataDocument((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }
  const getCategoryName = useQuery(['categoryName', id, sId], () =>
    getCategoryNameById(id, sId)
  )
  useEffect(() => {
    getCategoryName.refetch()

    // if (getCategoryName?.data) {
    setCategoryName(getCategoryName?.data?.category?.name || '')
    // }
    // Fetch the category name based on the id and set it
  }, [id, getCategoryName.data])

  // Function to pop the last element, update the state, and set the last id
  const popLastBreadcrumb = () => {
    console.log('updatedarray')
    setBreadcrumbArray &&
      setBreadcrumbArray((prevArray) => {
        // Create a copy of the current array and pop the last element
        const updatedArray = [...prevArray]
        updatedArray.pop()

        // Extract the id from the new last element, if it exists
        const newLastElement = updatedArray[updatedArray.length - 1]
        if (newLastElement) {
          setId(newLastElement.id)
        }

        return updatedArray
      })
  }

  return (
    <>
      <div
        className={
          'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-8 '
        }
      >
        <div
          style={{
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
            scrollbarWidth: 'none',
          }}
        >
          <UISubHeaderComponent
            mainPage={'Resources'}
            subPage={breadcrumbArray}
            copy="Please add your resource categories here. You can also specify the types of access to the candidate."
            onDelete={() => {}}
            isViewMode={false}
            isCreatePolicy={false}
            onBack={() => {
              setBreadcrumbArray && setBreadcrumbArray([])
              setIsView('categories')
            }}
            isButton={true}
            buttonIcon="IconPlus"
            buttonLable={
              activeTab == 'Resources'
                ? 'Create Resource'
                : 'Create Sub Category'
            }
            isButtonOnClick={() => {
              activeTab == 'Resources'
                ? setIsOpenDocumentModal(!isOpenDocumentModal)
                : setIsOpenCreateModal(!isOpenCreateModal)

              handleChange('parentId', id)
            }}
            isButton2={true}
            buttonIcon2="IconUploadCloud"
            buttonLable2="upload Resource"
            isButtonOnClick2={() => {
              setIsOpenDocumentModal(!isOpenDocumentModal)
            }}
            onPrevious={popLastBreadcrumb}
          />
          <div className="mt-4">
            <UITabBar
              titles={['Sub Categories', 'Resources']}
              activeTab={activeTab}
              onPressTab={handlePressTab}
              containerStyle="mt-4"
              activeTabText="text-text2"
            />
            <div className="my-4">
              {activeTab == 'Sub Categories' && (
                <SubCategoriesTab
                  id={id}
                  sId={sId}
                  setCategoryName={setCategoryName}
                  categoryName={categoryName}
                  // setParentCategoryName={setParentCategoryName}
                  setId={setId}
                  setBreadcrumbArray={setBreadcrumbArray}
                />
              )}
              {activeTab == 'Resources' && (
                <ResourcesTab id={id} sId={sId} categoryName={categoryName} />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Create Category Modal */}
      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 6px' }}
        isOpen={isOpenCreateModal}
        onClose={() => setIsOpenCreateModal(!isOpenCreateModal)}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => setIsOpenCreateModal(!isOpenCreateModal)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconTool'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Create Sub Category
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please specify the name and access of this sub category
            </p>
          </div>
          <div className="w-[416px] flex-col flex gap-8 mt-6">
            <div>
              <UITextInput
                label={'Sub Category Name*'}
                value={formData.name}
                onChange={(e) => {
                  handleChange('name', e.target.value)
                }}
                placeholder="Please enter your sub category name"
                iconName={''}
              />
            </div>
            <div className="w-full p-4 bg-gray1 rounded-xl flex">
              <div className="flex-1">
                <p className="text-sm font-semibold leading-6 text-text4">
                  Staff Access
                </p>
                <p className="text-sm font-normal leading-6 text-text3">
                  Can clients access files in this sub category?
                </p>
              </div>
              <div>
                <UISwitch
                  value={formData.candidateAccess}
                  onValueChange={(e: boolean) => {
                    handleChange('candidateAccess', e)
                  }}
                />
              </div>
            </div>
            <div className="flex flex-col gap-1">
              <p className="text-xs font-medium leading-5 text-text1">
                Resource Documents
              </p>
              {selectedFile ? (
                <div className="w-full p-5 py-3 bg-gray1 rounded-xl flex gap-2">
                  <div className="mt-1">
                    <Icon
                      name={'IconFile'}
                      stroke={'#02698C'}
                      strokeWidth={1}
                      height={16}
                      width={16}
                    />
                  </div>
                  <div className="flex flex-col flex-1 gap-2">
                    <div className="flex gap-2 items-center">
                      <p className="text-sm font-semibold leading-6 text-bluishGreen flex-1 p-0">
                        {selectedFile?.name}
                      </p>
                      <p className="text-xs font-medium leading-5 text-[#01B38B] p-0">
                        Upload Successful
                      </p>
                      <Icon
                        name={'IconCheck'}
                        stroke={'#01B38B'}
                        strokeWidth={1}
                        height={16}
                        width={16}
                      />
                      <div
                        className="cursor-pointer"
                        onClick={handleRemoveFile}
                      >
                        <Icon
                          name={'IconTrash'}
                          stroke={'#02698C'}
                          strokeWidth={1}
                          height={16}
                          width={16}
                        />
                      </div>
                    </div>
                    <div className="rounded-full w-full h-1 bg-[#01B38B]"></div>
                  </div>
                </div>
              ) : (
                <div
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  className="w-full p-5 py-3 bg-gray1 rounded-xl flex border-2 border-dashed border-gray3 border-separate border-spacing-3"
                >
                  <div className="flex flex-1 items-center gap-2">
                    <Icon
                      name={'IconUploadCloud'}
                      stroke={'#02698C'}
                      strokeWidth={1.5}
                      height={20}
                      width={20}
                    />
                    <p className="font-medium text-xs leading-5 text-text1">
                      Drop your file here or
                    </p>
                  </div>
                  <label htmlFor="fileInput">
                    <div
                      onClick={() => console.log('file upload')}
                      className="cursor-pointer flex items-center gap-2 bg-bluishGreen p-4 py-3 rounded-full"
                    >
                      <Icon
                        name={'IconUploadCloud'}
                        stroke={'#FFFFFF'}
                        strokeWidth={1.5}
                        height={20}
                        width={20}
                      />
                      <p className="font-medium text-xs leading-5 text-text8">
                        Choose a file to upload
                      </p>
                      <input
                        id="fileInput"
                        type="file"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        accept={'.pdf, .doc, .docx, .jpg, .jpeg, .png, .svg'}
                      />
                    </div>
                  </label>
                </div>
              )}
              <p className="text-xs font-medium leading-5 text-text3">
                Maximum file size: 5 mb
              </p>
            </div>
            <UIButton
              onClick={createNewSubCategory}
              type="submit"
              label="Create"
            />
          </div>
        </div>
      </Modal>

      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 6px' }}
        isOpen={isOpenDocumentModal}
        onClose={() => setIsOpenDocumentModal(!isOpenDocumentModal)}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => setIsOpenDocumentModal(!isOpenDocumentModal)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconTool'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>Add Resource</h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please specify the name of Resource
            </p>
          </div>
          <div className="w-[416px] flex-col flex gap-8 mt-6">
            <div>
              <UITextInput
                label={'Document Title*'}
                value={formDataDocument.name}
                onChange={(e) => {
                  handleFileDataChange('name', e.target.value)
                }}
                placeholder="Please enter document name"
                iconName={''}
              />
            </div>

            <div className="flex flex-col gap-1">
              <p className="text-xs font-medium leading-5 text-text1">
                Resource Document
              </p>
              {selectedFile ? (
                <div className="w-full p-5 py-3 bg-gray1 rounded-xl flex gap-2">
                  <div className="mt-1">
                    <Icon
                      name={'IconFile'}
                      stroke={'#02698C'}
                      strokeWidth={1}
                      height={16}
                      width={16}
                    />
                  </div>
                  <div className="flex flex-col flex-1 gap-2">
                    <div className="flex gap-2 items-center">
                      <p className="text-sm font-semibold leading-6 text-bluishGreen flex-1 p-0">
                        {selectedFile?.name}
                      </p>
                      <p className="text-xs font-medium leading-5 text-[#01B38B] p-0">
                        Upload Successful
                      </p>
                      <Icon
                        name={'IconCheck'}
                        stroke={'#01B38B'}
                        strokeWidth={1}
                        height={16}
                        width={16}
                      />
                      <div
                        className="cursor-pointer"
                        onClick={handleRemoveFile}
                      >
                        <Icon
                          name={'IconTrash'}
                          stroke={'#02698C'}
                          strokeWidth={1}
                          height={16}
                          width={16}
                        />
                      </div>
                    </div>
                    <div className="rounded-full w-full h-1 bg-[#01B38B]"></div>
                  </div>
                </div>
              ) : (
                <div
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  className="w-full p-5 py-3 bg-gray1 rounded-xl flex border-2 border-dashed border-gray3 border-separate border-spacing-3"
                >
                  <div className="flex flex-1 items-center gap-2">
                    <Icon
                      name={'IconUploadCloud'}
                      stroke={'#02698C'}
                      strokeWidth={1.5}
                      height={20}
                      width={20}
                    />
                    <p className="font-medium text-xs leading-5 text-text1">
                      Drop your file here or
                    </p>
                  </div>
                  <label htmlFor="fileInput">
                    <div
                      onClick={() => console.log('file upload')}
                      className="cursor-pointer flex items-center gap-2 bg-bluishGreen p-4 py-3 rounded-full"
                    >
                      <Icon
                        name={'IconUploadCloud'}
                        stroke={'#FFFFFF'}
                        strokeWidth={1.5}
                        height={20}
                        width={20}
                      />
                      <p className="font-medium text-xs leading-5 text-text8">
                        Choose a file to upload
                      </p>
                      <input
                        id="fileInput"
                        type="file"
                        onChange={handleFileChangeMainCategory}
                        style={{ display: 'none' }}
                        accept={'.pdf, .doc, .docx, .jpg, .jpeg, .png, .svg'}
                      />
                    </div>
                  </label>
                </div>
              )}
              <p className="text-xs font-medium leading-5 text-text3">
                Maximum file size: 5 mb
              </p>
            </div>
            <div className="w-full p-4 bg-gray1 rounded-xl flex">
              <div className="flex-1">
                <p className="text-sm font-semibold leading-6 text-text4">
                  Staff Access
                </p>
                <p className="text-sm font-normal leading-6 text-text3">
                  Can access files in this category?
                </p>
              </div>
              <div>
                <UISwitch
                  value={formDataDocument.candidateAccess}
                  onValueChange={(e: boolean) => {
                    handleFileDataChange('candidateAccess', e)
                  }}
                />
              </div>
            </div>

            <UIButton
              onClick={createNewResource}
              type="submit"
              label="Create"
            />
          </div>
        </div>
      </Modal>
    </>
  )
}

export default SubCategories
